export default __webpack_public_path__ + "static/media/Delivery-Type_Large_V2.a39d42dc.jpg";